import { render, staticRenderFns } from "./CustomerHistoryTicketTable.vue?vue&type=template&id=a858c5c6&scoped=true&"
import script from "./CustomerHistoryTicketTable.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryTicketTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHistoryTicketTable.vue?vue&type=style&index=0&id=a858c5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a858c5c6",
  null
  
)

export default component.exports